import React, { useEffect } from 'react';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';

import { useIntl } from '@atlassian/jira-intl';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';

import { AlikeSmartLink } from '../alike-smart-link/index.tsx';
import messages from './messages.tsx';

const styles = cssMap({
	popupEditViewStyle: {
		paddingLeft: token('space.100'),
		paddingTop: token('space.050'),
		paddingBottom: token('space.050'),
		borderBottom: `${token('border.width')} solid transparent`,
		borderTop: `${token('border.width')} solid transparent`,
	},
});

export const RestrictedIcon = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<LockLockedIcon
			label={formatMessage(messages.restrictedProject)}
			size="small"
			color={token('color.icon.danger')}
		/>
	);
};

export const RestrictedAlikeSmartLink = ({
	popupEditView = false,
}: {
	popupEditView?: boolean;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		fireTrackAnalytics(createAnalyticsEvent({}), 'atlasProjectRestrictedAlikeSmartLink viewed', {
			popupEditView,
		});
	}, [createAnalyticsEvent, popupEditView]);

	const linkContent = () => (
		<AlikeSmartLink icon={<RestrictedIcon />} content={formatMessage(messages.restrictedProject)} />
	);

	return popupEditView ? (
		<Box xcss={styles.popupEditViewStyle}>{linkContent()}</Box>
	) : (
		linkContent()
	);
};
